export default class FilterUtils {
  public static formatValue(value: string): string {
    const excludedCharacters = ['¥', 'R', '$', '%', '.', ' '];
    return value.split('')
      .filter((el) => !excludedCharacters.includes(el))
      .join('')
      .replace(',', '.');
  }
}
